import { writable, type Readable, type Writable } from 'svelte/store';

const storesDict: Record<string, Writable<any>> = {};

export const message = writable({ active: false, text: '', type: '', errors: [], app: false });
export const confirm = writable({
	active: false,
	text: '',
	okText: '',
	cancelText: '',
	action: null,
	wrap: false,
	app: false
});

export const edited = writable(false);

export const pin = writable(true);
export const editPin = writable(false);

export const petLevels = writable({});
export const editPet = writable({ active: false, selected: null, name: null });
export const newPetName = writable('');
export const newChosenPet = writable(null);

export const questionErrors = writable(false);
export const guardianErrors = writable(false);

export const newPet = writable({ active: false, pet: '' });
export const newAnswer = writable(false);

export const reading = writable(false);

export const chatBadgeActive = writable(false); //Only used when clicking on chat button, to check wether status should be updated in BE.
export const newChatMessage = writable('');

export const stats = writable({ symptom: 'all', type: 'scale', span: 'day', scalePos: false });
export const selectedDates = writable({ from: null, to: null, now: null });

export const user = writable('');

export const noTargets = writable(false);

export const disableBtns = writable(false);

export const logoutClick = writable(false);

export const visibleSlide = writable(0);
export const visibleSubSlide = writable(0);
export const visibleInfoSlide = writable(0);

export const assessInfoOverlay = writable(false);
export const petInfoOverlay = writable(false);
export const subOverlay = writable(false);
export const agreementOverlay = writable(false);
export const privacyOverlay = writable(false);
export const aboutOverlay = writable(false);

export const pushActivation = useStorage('pushActivation', false);
export const assessmentPrompt = writable(false);
export const chatPrompt = writable(false)

export const assessmentFilters = writable({ customerVal: '0', sortVal: '-date_created', targetVal: '0', statusDraft: true, statusPublished: true, statusArchived: false, category: '0' });
export const appuserFilters = writable({ customerVal: '0', sortVal: '-date_created', targetVal: '0', statusActive: true, statusSuspended: false, });
export const adminuserFilters = writable({ customerVal: '0', sortVal: '-date_created', targetVal: '0', adminGlobal: true, adminCustomer: true, adminProject: true, translator: false, statusActive: true, statusSuspended: false, });
export const targetFilters = writable({ customerVal: '0', sortVal: '-date_created', minAge: null, maxAge: null });
export const analyticsFilters = writable({ customerVal: '0', sortVal: 'date_user_submitted', targetVal: '0', selectedUser: '0', from: null, to: null, excludeArchived: false });
export const chatFilters = writable({ customerVal: '0', sortVal: '-admin_status', targetVal: '0', statusUnattended: true, statusAttended: true, statusArchived: false });
export const imageFilters = writable({ unattached: true, attached: true, sortVal: '-created_on', customerVal: '0', category: '0', creator: '0' })
export const hintFilters = writable({ unattached: true, attached: true, sortVal: '-date_created', customerVal: '0', category: '0', creator: '0' })

export const imageCurrentCaption = writable('');
export const imageCurrentListItem = writable('');
export const imageCurrentLang = writable('');
export const captionDialog = writable(false);

export const resetSlice = writable(false);

export const pinAttempts = writable(0);

export function useStorage<T>(key, initialValue: T): Writable<T> {
	const existing = storesDict[key];
	if (existing) {
		return existing;
	}

	if (typeof window === 'undefined') {
		const store = writable(initialValue);
		storesDict[key] = store;
		return store;
	}

	let serialize = JSON.stringify;
	let deserialize = JSON.parse;

	let storedValue = deserialize(localStorage?.getItem(key) || 'null') as T;

	let store = writable(
		storedValue !== undefined && storedValue !== null ? storedValue : initialValue
	);
	store.subscribe((value) => localStorage?.setItem(key, serialize(value)));
	storesDict[key] = store;

	return store;
}

export function distinctUntilChanged<T>(store: Readable<T>): Readable<T> {
	return {
		subscribe: (set, invalidate) => {
			let lastJson: string | undefined = undefined;
			return store.subscribe((value) => {
				const json = JSON.stringify(value);
				if (lastJson != json) {
					lastJson = json;
					set(value);
				}
			});
		}
	};
}
